import React from 'react';
import {AppContext} from '../../../AppModule/Context';
import {withWidgetContext} from '../widgetContextProvider';

import MultiDagComponent from './multiDagComponent';
import MultiEngagerReceiverComponent from './multiEngagerReceiverComponent';
import multiWidgetService from '../../../services/multiWidgetService';
import OpenMultiWidgetComponent from './openMultiWidgetComponent';
import WidgetMaskComponentV2 from '../widgetMaskComponentV2';

import AnalyticsService from '../../../services/analyticsService';
import peerAvailabilityStateService from '../../../services/peerAvailabilityStateService';
import PostMessageService from '../../../services/postMessageService';
import {
  ListeningRoomService,
  ShoutingRoomService,
} from '../../../services/websocketService';
import storageService from '../../../services/storageService';
import utilsService from '../../../services/utilsService';

import VIDABOO_CONSTANTS from '../../../config/consts';

import './multiExpertWidget.css';

/**
 * Created by Ilan Harel
 */
class MultiExpertWidget extends React.Component {
  constructor() {
    super();
    this.state = {
      shouldSkipAgentListUI: false,
      // widgetDto: props.widgetDto,
      widgetMode: VIDABOO_CONSTANTS.WIDGET_MODES.MASK_MODE,
      isSingleWidgetMounted: false,
      singleWidgetMentorId: null,
      filteredSortedMentorsCtrlDtoValues: [],
      isEntireWidgetHidden: true,
      isInitialWidgetTextShown: false,
    };
    this.isInPersonalPage = utilsService.getIsPersonalPage();
    this.isSingleWidget = false;

    PostMessageService.setMultiWidget(true);
  }

  componentDidMount = () => {
    this.deleteConnectToPeerShoutingRoom = {};
    this.deleteConnectToPeerListeningRoom = {};
    this.deleteDoWhenAvailabilityStateChanged = {};
    this.setState({validatePageRegexesTrials: 0});
    this.init();
    this.registerActions();
  };

  componentDidUpdate = (prevProps) => {
    //when widgetDto is changed in backoffice side in demo mode or in case of team chat transition
    if (
      (this.props.isDemo &&
        this.props.widgetDto &&
        this.props.widgetDto !== prevProps.widgetDto) ||
      (this.props.currentlyActiveMentorId &&
        prevProps.currentlyActiveMentorId !==
          this.props.currentlyActiveMentorId)
    ) {
      this.init();
    } else if (this.props.inTeamChatScenario !== prevProps.inTeamChatScenario) {
      // handling case when widget is in LIST AND CHAT mode and customer clicks on back button in header inside team chat then we need to show the agent list not the mask
      const shouldSetWidgetToAccountMode =
        this.state.widgetDto.widgetAppCtrlDto.widgetInteractionMode ===
          VIDABOO_CONSTANTS.WIDGET_INTERACTION_MODE.LIST_AND_CHAT &&
        prevProps.inTeamChatScenario;
      this.init(shouldSetWidgetToAccountMode);
    }
    if (this.peersStatus !== this.context.peersStatus && this.state.widgetDto) {
      this.peersStatus = this.context.peersStatus;

      this.handleMentorsVisibilityStatus(
        this.state.widgetDto.mentorsControlMapDto,
      );
      this.handleWidgetAndMentorsPageRegex(this.state.widgetDto);

      const sortedVisiblePageRegPassedMentorsCtrlDtoValues =
        this.handleMentorsCtrlMapDtoSortAndFiltering(
          this.state.widgetDto,
          this.state.maxNumOfWidgetsAfterPageRegex,
        );
      this.setState({
        filteredSortedMentorsCtrlDtoValues:
          sortedVisiblePageRegPassedMentorsCtrlDtoValues,
        maxNumOfWidgets: sortedVisiblePageRegPassedMentorsCtrlDtoValues.length,
      });
      PostMessageService.setNumOfWidgets(
        sortedVisiblePageRegPassedMentorsCtrlDtoValues.length,
      );
      if (sortedVisiblePageRegPassedMentorsCtrlDtoValues.length === 1) {
        this.isSingleWidget = true;
        this.isMultiWidget = false;
      } else {
        this.isSingleWidget = false;
        this.isMultiWidget =
          (!this.isInPersonalPage && !this.isSingleWidget) ||
          this.props.isDirectory;
      }
    }
  };

  componentWillUnmount = () => {
    clearTimeout(this.validatePageRegexTimeout);
    this.doDeleteWhenActionClick();
    Object.keys(this.deleteConnectToPeerShoutingRoom).forEach((peerUserId) => {
      this.deleteConnectToPeerShoutingRoom[peerUserId]();
    });
    Object.keys(this.deleteConnectToPeerListeningRoom).forEach((peerUserId) => {
      this.deleteConnectToPeerListeningRoom[peerUserId]();
    });
    Object.keys(this.deleteDoWhenAvailabilityStateChanged).forEach(
      (peerUserId) => {
        this.deleteDoWhenAvailabilityStateChanged[peerUserId]();
      },
    );
    if (this.widgetAutoPopupTimeout) {
      window.clearTimeout(this.widgetAutoPopupTimeout);
    }
  };

  sendPageviewAnalyticsEvent = () => {
    if (this.props.isDemo || this.props.isDirectory) return;
    const pageLocation = this.getPageLocation();

    // Send pageview events for individual mentors
    // Note : for personal page, the mentorsControlMapDto contains only one mentorDto which is linked with profileName
    const oneOnOneMentors = this.state.widgetDto.mentorsControlMapDto || {};
    Object.values(oneOnOneMentors).forEach((widgetMentorCtrlDto) => {
      const mentorDto = widgetMentorCtrlDto.extendedMentorDto.mentorDto;
      this.sendPageviewAnalyticsEventForMentor(mentorDto, pageLocation);
    });

    // Send pageview events for team mentors
    const teamMentorCtrlDto =
      !this.isInPersonalPage &&
      this.state.widgetDto.widgetAppCtrlDto.widgetInteractionMode !==
        VIDABOO_CONSTANTS.WIDGET_INTERACTION_MODE.TEAM_LIST
        ? multiWidgetService.getFirstWidgetTeamMentorCtrlDto(
            this.state.widgetDto,
          )
        : null;

    if (teamMentorCtrlDto) {
      const teamMentorDto = teamMentorCtrlDto.extendedMentorDto.mentorDto;
      this.sendPageviewAnalyticsEventForMentor(teamMentorDto, pageLocation);
    }
  };

  sendPageviewAnalyticsEventForMentor = (mentorDto, pageLocation) => {
    const analyticsEventData = {
      category: this.isInPersonalPage
        ? VIDABOO_CONSTANTS.ANALYTICS_CATEGORIES.FRONT_PAGE
        : VIDABOO_CONSTANTS.ANALYTICS_CATEGORIES.WIDGET,
      action: VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.PAGEVIEW.ENTER_PAGE,
      senderCreationTime: new Date().getTime(),
      userId: this.context.currentUser.userId,
      mentorId: mentorDto.mentorId,
      userRole: this.context.currentUser.role,
      error: pageLocation.error,
      dimensionsMap: {
        fullUrl: pageLocation.fullUrl,
        hostUrl: pageLocation.hostUrl,
        pageUrl: pageLocation.pageUrl,
        hashUrl: pageLocation.hashUrl,
        searchStr: pageLocation.searchStr,
        widget: utilsService.getIsInWidget(),
        widgetId: this.state.widgetDto.widgetId,
        deviceType: navigator.userAgent,
        timezone: new Date().getTimezoneOffset(),
      },
    };

    AnalyticsService.saveConsoltoAnalyticsEvent(analyticsEventData);
    this.sendGA(
      VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.PAGEVIEW.ENTER_PAGE,
      mentorDto.profileName,
      true,
    );
  };

  init = (shouldSetWidgetToAccountMode) => {
    let widgetDto = JSON.parse(JSON.stringify(this.props.widgetDto));

    if (!widgetDto.isActive) {
      this.hideEntireWidget();
      return;
    }

    // if currentlyActiveMentorId is present that means we are in team chat scenario but for some reason like action clicks, task owner ... we need to show 1x1 room of active mentor
    if (this.props.currentlyActiveMentorId) {
      this.preserveOnlyActiveMentor(
        widgetDto,
        this.props.currentlyActiveMentorId,
      );
    }

    this.isSingleWidget =
      Object.values(widgetDto.mentorsControlMapDto).length === 1;
    this.isMultiWidget =
      (!this.isInPersonalPage && !this.isSingleWidget) ||
      this.props.isDirectory;

    let shouldSkipAgentListUI = this.isSingleWidget || this.isInPersonalPage;
    let isEntireWidgetHidden = true;
    let filteredSortedMentorsCtrlDtoValues = [];

    if (!this.isInPersonalPage) {
      this.setWidgetProfileImgAndVideoBgUrl();
    }

    //1. filter inactive mentors -> already done in widgetContainerComponent
    //2. if personal page -> remove all mentors from mentorsControlMapDto except the one who is linked with profileName (to prevent listening to socket...)
    //3. filter non -visible mentors
    //4. handle widget and mentor page regexes
    //5. if at this stage, 0 agent left ->  hideEntireWidget, if there is only 1 agent left, treat the widget as singleWidget,
    //6. sort and filter mentor list
    //7. assign and update state

    if (this.isInPersonalPage) {
      this.filterProfileNameUnMatchedMentors(widgetDto);
    }
    this.handleMentorsVisibilityStatus(widgetDto.mentorsControlMapDto);
    const result = this.handleWidgetAndMentorsPageRegex(widgetDto);
    this.setState({maxNumOfWidgetsAfterPageRegex: result.maxNumOfWidgets});
    this.handleMentorsOrderAndListeningRoom(widgetDto);

    const visiblePassedPageRegexMentorsArr =
      Object.values(widgetDto.mentorsControlMapDto ?? {}).filter(
        (mentorControlMapDto) =>
          mentorControlMapDto.isWidgetShown &&
          mentorControlMapDto.extendedMentorDto.isVisible &&
          mentorControlMapDto.extendedMentorDto.passedPageRegex,
      ) ?? [];

    if (!this.isInPersonalPage && !this.isSingleWidget) {
      filteredSortedMentorsCtrlDtoValues =
        this.handleMentorsCtrlMapDtoSortAndFiltering(
          widgetDto,
          result.maxNumOfWidgets,
        );
      if (visiblePassedPageRegexMentorsArr.length === 1) {
        this.isSingleWidget = true;
        this.isMultiWidget = false;
        shouldSkipAgentListUI = true;
      }
    }

    const widgetMode = this.props.isDirectory
      ? VIDABOO_CONSTANTS.WIDGET_MODES.DIRECTORY
      : this.isInPersonalPage
        ? VIDABOO_CONSTANTS.WIDGET_MODES.SINGLE_EXPERT_MODE
        : shouldSetWidgetToAccountMode
          ? VIDABOO_CONSTANTS.WIDGET_MODES.ACCOUNT_MODE
          : VIDABOO_CONSTANTS.WIDGET_MODES.MASK_MODE;
    const widgetMaskText =
      (widgetDto.widgetAppCtrlDto.widgetEditableTexts &&
        widgetDto.widgetAppCtrlDto.widgetEditableTexts[
          VIDABOO_CONSTANTS.WIDGET_EDITABLE_TEXTS.PRE_WIDGET_TEXT
        ]) ??
      this.context.languageSet.CONSOLTO_WIDGET['LETS_TALK'];
    PostMessageService.setWidgetInfo({
      widgetInteractionMode: widgetDto.widgetAppCtrlDto.widgetInteractionMode,
      closedWidgetType: widgetDto.widgetAppCtrlDto.closedWidgetType,
      locationOnScreen: widgetDto.widgetAppCtrlDto.style.locationOnScreen,
      widgetMaskText,
      widgetHorizontalDistance:
        widgetDto.widgetAppCtrlDto.style?.widgetHorizontalDistance,
      widgetVerticalDistance:
        widgetDto.widgetAppCtrlDto.style?.widgetVerticalDistance,
      widgetSize: widgetDto.widgetAppCtrlDto.style?.widgetSize,
    });
    PostMessageService.setNumOfWidgets(
      filteredSortedMentorsCtrlDtoValues.length,
    );
    let widgetSizeType = VIDABOO_CONSTANTS.WIDGET_SIZE.WIDGET_CLOSED;
    if (this.props.isChatTransitionFlowRunning) {
      widgetSizeType = PostMessageService.getWidgetSize();
    }
    if (shouldSetWidgetToAccountMode) {
      widgetSizeType = VIDABOO_CONSTANTS.WIDGET_SIZE.ACCOUNT_WIDGET_OPEN;
    }
    this.changeIframeSize(widgetSizeType, 'multiExpertWidget', null, {
      locationOnScreen: widgetDto.widgetAppCtrlDto.style.locationOnScreen,
    });

    if (
      !widgetDto.widgetAppCtrlDto.widgetVisible ||
      visiblePassedPageRegexMentorsArr.length === 0 ||
      !result.isWidgetPageRegexPassed ||
      result.maxNumOfWidgets === 0
    ) {
      //hide widget
      if (!this.props.isDemo) {
        if (this.isSingleWidget || this.isMultiWidget) {
          isEntireWidgetHidden = true;
          this.hideEntireWidget();
        }
      } else {
        isEntireWidgetHidden = false;
      }
    } else {
      isEntireWidgetHidden = false;
      if (this.props.isChatTransitionFlowRunning) {
        this.showEntireWidget();
        this.handleWidgetAutoPopup(widgetDto, true);
      } else {
        if (!this.props.isDemo && (this.isSingleWidget || this.isMultiWidget)) {
          this.showEntireWidget();
          // Show only if the widgetVisible is true and maxNo.of widget are greater than 0
          if (
            this.checkIfNeedAutoOpen(widgetDto) &&
            !widgetDto.widgetAppCtrlDto.preWidgetEnabled
          ) {
            this.handleWidgetAutoPopup(widgetDto);
          }
        }
      }
    }

    const userWidgetLanguage = storageService.getItem('userWidgetLanguage')
      ? JSON.parse(storageService.getItem('userWidgetLanguage'))
      : {};
    this.context.setLanguage(
      userWidgetLanguage[this.context.currentUser.userId] ||
        widgetDto.widgetAppCtrlDto.uiLanguage ||
        'ENGLISH',
    );

    if (!this.props.isDemo) {
      utilsService.assignWidgetCustomizationValues(
        widgetDto.widgetAppCtrlDto.style,
        widgetDto.widgetAppCtrlDto.style,
      );
    }

    this.setState(
      {
        widgetMode,
        widgetDto,
        shouldSkipAgentListUI,
        maxNumOfWidgets: filteredSortedMentorsCtrlDtoValues.length,
        isEntireWidgetHidden,
        filteredSortedMentorsCtrlDtoValues,
      },
      () => {
        this.sendPageviewAnalyticsEvent();
      },
    );
  };

  preserveOnlyActiveMentor = (widgetDto, mentorIdToBeKept) => {
    Object.keys(widgetDto.mentorsControlMapDto).forEach((mentorId) => {
      if (mentorIdToBeKept && mentorId !== mentorIdToBeKept) {
        delete widgetDto.mentorsControlMapDto[mentorId];
      }
    });
  };

  filterProfileNameUnMatchedMentors = (widgetDto) => {
    if (this.props.profileName) {
      const mentorIdLinkedToProfileName =
        multiWidgetService.getMentorIdUsingProfileName(
          this.props.profileName,
          widgetDto.mentorsControlMapDto,
        );
      Object.keys(widgetDto.mentorsControlMapDto).forEach((mentorId) => {
        if (
          widgetDto.mentorsControlMapDto[mentorId].extendedMentorDto.mentorDto
            .mentorId !== mentorIdLinkedToProfileName
        ) {
          delete widgetDto.mentorsControlMapDto[mentorId];
        }
      });
    }
  };

  handleMentorsVisibilityStatus = (mentorsControlMapDto) => {
    Object.keys(mentorsControlMapDto).forEach((mentorId) => {
      const mentorControlMapDto = mentorsControlMapDto[mentorId];
      if (
        mentorControlMapDto.isWidgetShown &&
        mentorControlMapDto.extendedMentorDto.mentorDto.appControlDto
          .widgetVisible
      ) {
        mentorsControlMapDto[mentorId].extendedMentorDto.isVisible = true;
      } else {
        mentorsControlMapDto[mentorId].extendedMentorDto.isVisible = false;
      }
    });
  };

  handleWidgetAndMentorsPageRegex = (widgetDto) => {
    let mentorsControlMapDto = widgetDto.mentorsControlMapDto;
    let isWidgetPageRegexPassed = false,
      maxNumOfWidgets = 0;
    const maxNumOfWidgetsByAccount = widgetDto.widgetAppCtrlDto.numOfWidgets;
    const pageRegexArr = widgetDto.widgetAppCtrlDto.pagesRegexes;

    if (this.validatePageRegexes(pageRegexArr) === true) {
      isWidgetPageRegexPassed = true;
    }

    const mentorIds = Object.keys(mentorsControlMapDto);
    let numOfWidgetsPassedRegex = 0;

    for (let index = 0; index < mentorIds.length; index++) {
      const mentorId = mentorIds[index];
      const userPageRegexArr = mentorsControlMapDto[mentorId].pagesRegexes;
      if (this.validatePageRegexes(userPageRegexArr)) {
        numOfWidgetsPassedRegex++;
        mentorsControlMapDto[mentorId].extendedMentorDto.passedPageRegex = true;
      } else {
        mentorsControlMapDto[mentorId].extendedMentorDto.passedPageRegex =
          false;
      }
    }
    maxNumOfWidgets = Math.min(
      maxNumOfWidgetsByAccount,
      numOfWidgetsPassedRegex,
    );
    return {isWidgetPageRegexPassed, maxNumOfWidgets};
  };

  handleMentorsOrderAndListeningRoom = (
    widgetDto,
    // isActionClickOpenWidgetBtn,
  ) => {
    let mentorsControlMapDto = widgetDto.mentorsControlMapDto;
    Object.keys(mentorsControlMapDto).forEach((mentorId) => {
      const extendedMentorDto =
        mentorsControlMapDto[mentorId].extendedMentorDto;
      const mentorUserId = extendedMentorDto.mentorDto.mentorOwnerId;
      const randomizedOrderValue = this.getAgentOrderValueByPriorityNum(
        mentorsControlMapDto[mentorId].priorityNum,
      );
      mentorsControlMapDto[mentorId].order = randomizedOrderValue;
      this.listenToPeerAvailabilityChanges(mentorUserId, widgetDto);
      // if (
      //   (extendedMentorDto.isVisible && extendedMentorDto.passedPageRegex) ||
      //   isActionClickOpenWidgetBtn
      // ) {
      //   this.listenToPeerAvailabilityChanges(mentorUserId, widgetDto);
      // }
    });
  };

  handleMentorsCtrlMapDtoSortAndFiltering = (
    widgetDto,
    maxNumOfWidgets,
    isActionClickOpenWidgetBtn,
  ) => {
    let mentorsControlMapDto = widgetDto.mentorsControlMapDto;
    let visiblePageRegPassedMentorsCtrlDtoValues = isActionClickOpenWidgetBtn
      ? Object.values(mentorsControlMapDto)
      : Object.values(mentorsControlMapDto).filter(
          (mentorControlMapDto) =>
            mentorControlMapDto.extendedMentorDto.passedPageRegex &&
            mentorControlMapDto.extendedMentorDto.isVisible,
        );
    visiblePageRegPassedMentorsCtrlDtoValues.forEach((widgetMentorCtrlDto) => {
      this.setMentorCtrlDtoState(widgetMentorCtrlDto, widgetDto);
    });

    if (
      widgetDto.widgetAppCtrlDto.availabilityFilter !==
      VIDABOO_CONSTANTS.AVAILABILITY_STATES.OFFLINE.toUpperCase()
    ) {
      let availableVisiblePageRegPassedMentorsCtrlDtoValues =
        visiblePageRegPassedMentorsCtrlDtoValues.filter(
          (mentorsCtrlMapDtoValue) => mentorsCtrlMapDtoValue.available === true,
        );

      const numOfFilteredWidgets =
        availableVisiblePageRegPassedMentorsCtrlDtoValues.length;

      if (numOfFilteredWidgets > maxNumOfWidgets) {
        availableVisiblePageRegPassedMentorsCtrlDtoValues =
          availableVisiblePageRegPassedMentorsCtrlDtoValues.slice(
            0,
            maxNumOfWidgets,
          );
      }
      if (
        availableVisiblePageRegPassedMentorsCtrlDtoValues.length === 0 &&
        visiblePageRegPassedMentorsCtrlDtoValues.length !== 0
      ) {
        // in case we're filtering by availability and there's no available agent, show the first one. Note that we should NOT show inactive agents.
        availableVisiblePageRegPassedMentorsCtrlDtoValues = [
          visiblePageRegPassedMentorsCtrlDtoValues.sort(
            this.compareWidgetMentorCtrlDtos,
          )[0],
        ];
      }
      visiblePageRegPassedMentorsCtrlDtoValues =
        availableVisiblePageRegPassedMentorsCtrlDtoValues;
    }

    visiblePageRegPassedMentorsCtrlDtoValues =
      visiblePageRegPassedMentorsCtrlDtoValues.sort(
        this.compareWidgetMentorCtrlDtos,
      );
    visiblePageRegPassedMentorsCtrlDtoValues =
      visiblePageRegPassedMentorsCtrlDtoValues.slice(0, maxNumOfWidgets);

    return visiblePageRegPassedMentorsCtrlDtoValues;
  };

  setMentorCtrlDtoState = (widgetMentorCtrlDto, widgetDto) => {
    const mentorUserId =
      widgetMentorCtrlDto.extendedMentorDto.mentorDto.mentorOwnerId;
    if (!this.props.isDemo && widgetDto.widgetAppCtrlDto.availabilitySort) {
      // adjusting order per availability
      // console.debug(widgetMentorCtrlDto.order);
      //assign initial value using priorityNum -> otherwise order will not work properly when AVAILABILITY_STATE of agent is changed
      const randomizedOrderValue = this.getAgentOrderValueByPriorityNum(
        widgetMentorCtrlDto.priorityNum,
      );
      widgetMentorCtrlDto.order = randomizedOrderValue;

      widgetMentorCtrlDto.order =
        this.context.peersStatus[mentorUserId] ===
        VIDABOO_CONSTANTS.AVAILABILITY_STATES.AVAILABLE
          ? widgetMentorCtrlDto.order
          : this.context.peersStatus[mentorUserId] ===
              VIDABOO_CONSTANTS.AVAILABILITY_STATES.BUSY
            ? widgetMentorCtrlDto.order / 10000
            : widgetMentorCtrlDto.order / 10000000;
    }
    widgetMentorCtrlDto.order = widgetMentorCtrlDto.order * 1e7 || 0;
    // console.debug(widgetMentorCtrlDto.order);
    if (
      !this.props.isDemo &&
      widgetDto.widgetAppCtrlDto.availabilityFilter &&
      widgetDto.widgetAppCtrlDto.availabilityFilter !==
        VIDABOO_CONSTANTS.AVAILABILITY_STATES.OFFLINE.toUpperCase()
    ) {
      widgetMentorCtrlDto.available =
        this.context.peersStatus[mentorUserId] ===
        VIDABOO_CONSTANTS.AVAILABILITY_STATES.AVAILABLE;
    } else {
      widgetMentorCtrlDto.available = true;
    }
  };

  compareWidgetMentorCtrlDtos = (
    widgetMentorCtrlDtoA,
    widgetMentorCtrlDtoB,
  ) => {
    // comparing by order. Availability should derive changes in the widget.order only if sorting by availability
    // console.debug(widgetMentorCtrlDtoA.order, ', ', widgetMentorCtrlDtoB.order);
    let comparison = 0;
    if (widgetMentorCtrlDtoA.order > widgetMentorCtrlDtoB.order) {
      comparison = -1;
    } else if (widgetMentorCtrlDtoB.order > widgetMentorCtrlDtoA.order) {
      comparison = 1;
    }
    return comparison;
  };

  getAgentOrderValueByPriorityNum = (priorityNum) => {
    const priorityNumValue = priorityNum ?? 0;
    return priorityNumValue * 100 + Math.round(Math.random() * 100);
  };

  checkIfNeedAutoOpen = (widgetDto) => {
    if (utilsService.isLocalStorageSupported()) {
      let lastMWCloseTime = storageService.getItem('lastMWClose');
      let lastMultiWidgetCloseTimes;
      if (lastMWCloseTime === null || lastMWCloseTime === undefined) {
        lastMultiWidgetCloseTimes = {};
      } else {
        lastMultiWidgetCloseTimes = JSON.parse(lastMWCloseTime);
      }
      let lastCloseTimeThisAccount =
        lastMultiWidgetCloseTimes[widgetDto.widgetId] || 0;
      let now = new Date().getTime();
      if (
        lastMultiWidgetCloseTimes[widgetDto.widgetId] === undefined ||
        now - lastCloseTimeThisAccount >=
          VIDABOO_CONSTANTS.CHAT_AUTO_RESPONDER.DEFAULT_TIME_BETWEEN_AUTO_CHATS
      ) {
        // lastMultiWidgetCloseTimes[widgetDto.accountId] = now;
        // storageService.setItem("lastMWClose", JSON.stringify(lastMultiWidgetCloseTimes)); // saving mentorUserId and lastTime autoChat was popped up
        return true;
      } else {
        return false;
      }
    } else {
      // If local storage is not supported, then auto open to be true
      return true;
    }
  };
  registerActions = () => {
    this.doDeleteWhenActionClick = PostMessageService.doWhenActionClick(
      this.doWhenActionClick,
    );
  };

  sendCA = (eventAction) => {
    AnalyticsService.saveConsoltoAnalyticsEvent({
      senderCreationTime: new Date().getTime(),
      userId: this.context.currentUser.userId,
      userRole: this.context.currentUser.role,
      error: null,
      category: VIDABOO_CONSTANTS.ANALYTICS_CATEGORIES.WIDGET,
      action: eventAction,
      dimensionsMap: {
        widget: true,
        accountId: this.state.widgetDto.accountId,
        widgetId: this.state.widgetDto.widgetId,
      },
    });
  };

  sendGA = (eventAction, label, noSendCA) => {
    AnalyticsService.trackEvent({
      category: this.isInPersonalPage
        ? VIDABOO_CONSTANTS.ANALYTICS_CATEGORIES.FRONT_PAGE
        : VIDABOO_CONSTANTS.ANALYTICS_CATEGORIES.WIDGET,
      action: eventAction,
      label: label,
      value: '',
      sendToParent: this.isInPersonalPage
        ? false
        : this.state.widgetDto.widgetAppCtrlDto.enableWidgetAnalyticsForward ===
          true,
    });
    if (!noSendCA) this.sendCA(eventAction);
  };

  dispatchConsoltoEvents = (eventAction, label) => {
    if (
      utilsService.getIsInWidget() &&
      this.state.widgetDto.widgetAppCtrlDto.dispatchConsoltoWidgetEvents
    ) {
      const eventObj = {
        category:
          VIDABOO_CONSTANTS.ANALYTICS_CATEGORIES.WIDGET_FOR_PARENT_FRAME,
        action: eventAction,
        label: label,
        value: '',
      };
      PostMessageService.sendEventToHost(eventObj);
    }
  };

  changeIframeSize = (size, initiator, visibility, postMsgData) => {
    PostMessageService.postMessageResize(size, initiator, postMsgData);
    if (visibility) {
      this.changeIframeVisibility(visibility, initiator);
    }
  };
  changeIframeVisibility = (visibility, initiator) => {
    PostMessageService.postMessageHide(visibility, initiator);
  };
  getAvailableAgent = () => {
    const availablePeerIds = [];
    const peerIds = Object.keys(this.context.peersStatus);
    peerIds.forEach((peerId) => {
      if (
        this.context.peersStatus[peerId] ===
        VIDABOO_CONSTANTS.AVAILABILITY_STATES.AVAILABLE
      ) {
        availablePeerIds.push(peerId);
      }
    });
    if (availablePeerIds.length < 1)
      return peerIds[Math.floor(Math.random() * peerIds.length)];
    return availablePeerIds[
      Math.floor(Math.random() * availablePeerIds.length)
    ];
  };

  doWhenActionClick = (actionClickData) => {
    if (
      this.state.widgetDto.widgetAppCtrlDto.widgetInteractionMode ===
      VIDABOO_CONSTANTS.WIDGET_INTERACTION_MODE.TEAM_LIST
    ) {
      this.handleTeamListInteractionModeActionClick(actionClickData);
    } else if (
      this.state.widgetDto.widgetAppCtrlDto.widgetInteractionMode ===
      VIDABOO_CONSTANTS.WIDGET_INTERACTION_MODE.LIST_AND_CHAT
    ) {
      this.handleListAndChatInteractionModeActionClick(actionClickData);
    } else if (
      this.state.widgetDto.widgetAppCtrlDto.widgetInteractionMode ===
      VIDABOO_CONSTANTS.WIDGET_INTERACTION_MODE.TEAM_WIDGET
    ) {
      this.handleTeamWidgetInteractionModeActionClick(actionClickData);
    }
  };

  handleTeamListInteractionModeActionClick = (actionClickData) => {
    // Supporting legacy
    // in case of single widget, even if agent id is not present -> set the mentorId
    const isSingleWidget =
      Object.keys(this.props.widgetDto.mentorsControlMapDto).length === 1;
    if (isSingleWidget) {
      actionClickData.etAgentId = Object.keys(
        this.props.widgetDto.mentorsControlMapDto,
      )[0];
    }

    if (
      actionClickData.clientInfo &&
      actionClickData.cFirstName &&
      actionClickData.cEmail
    ) {
      if (!actionClickData.etAgentId) {
        console.error(
          'Consolto Widget: tried to perform action without a widgetId',
        );
        return;
      }
      actionClickData.mentorOwnerId =
        multiWidgetService.getPeerUserIdUsingMentorId(
          actionClickData.etAgentId,
          this.props.widgetDto.mentorsControlMapDto,
        );
      const actionClickExMentorDto =
        multiWidgetService.getExMentorDtoByMentorOwnerId(
          actionClickData.mentorOwnerId,
          this.props.widgetDto,
        );
      if (actionClickExMentorDto) {
        actionClickData.mentorId = actionClickExMentorDto.mentorDto.mentorId;
      }
      if (actionClickData.mentorOwnerId && actionClickData.mentorId) {
        this.setState({actionClickData});
        utilsService.savePeerClientInfo(actionClickData, this.props.widgetDto);
        this.props.widgetContext.setIsPeerClientInfoUpdated(true);
      } else {
        console.error('Consolto Widget: invalid etAgentId');
        return;
      }
    }

    if (actionClickData && !utilsService.getIsPersonalPage()) {
      // If bfi is available then give priority to bfi
      if (actionClickData.bfi) {
        const peerUserId = actionClickData.etAgentId;
        if (!peerUserId) {
          console.error(
            'Consolto Widget: tried to open widget without a widgetId',
          );
          return;
        }
        this.setState({actionClickData});
        this.openWidgetByPeerUserIdOrMentorId(peerUserId);

        return;
      }
    }
    if (actionClickData.etAgentId === 'AVAILABLE') {
      actionClickData.etAgentId = this.getAvailableAgent();
    }
    if (
      actionClickData.etClickType === 'start-chat' ||
      actionClickData.etConsoltoStart ===
        VIDABOO_CONSTANTS.TRIGGER_ACTIONS.TEXT_CHAT
    ) {
      const peerUserId = actionClickData.etAgentId;
      if (!peerUserId) {
        console.error(
          'Consolto Widget: tried to open widget without a widgetId',
        );
        return;
      }
      this.setState({actionClickData});
      this.openWidgetByPeerUserIdOrMentorId(peerUserId);
      return;
    } else if (
      actionClickData.etClickType === 'open-widget' ||
      actionClickData.etConsoltoStart ===
        VIDABOO_CONSTANTS.TRIGGER_ACTIONS.OPEN_WIDGET
    ) {
      const peerUserId = actionClickData.etAgentId;
      if (!peerUserId) {
        console.error(
          'Consolto Widget: tried to open widget without a widgetId',
        );
        return;
      }
      this.setState({actionClickData});
      if (actionClickData.etAgentId === 'multi') {
        this.handleActionClickWidgetOpen();
      } else {
        this.openWidgetByPeerUserIdOrMentorId(peerUserId);
      }
    } else if (actionClickData.etClickType === 'close-widget') {
      // const peerUserId = actionClickData.etAgentId;
      // if (!peerUserId) {
      //   console.error(
      //     'Consolto Widget: tried to open widget without a widgetId',
      //   );
      // }
      this.setState(
        {
          actionClickData: null,
          isSingleWidgetMounted: false,
          singleWidgetMentorId: null,
          openSingleWidgetByPeerId: null,
        },
        () => {
          this.closeMultiWidget(true);
        },
      );
    } else if (
      actionClickData.etClickType === 'start-call' ||
      actionClickData.etClickType === 'start-audio-call' ||
      actionClickData.etConsoltoStart ===
        VIDABOO_CONSTANTS.TRIGGER_ACTIONS.VIDEO_CALL ||
      actionClickData.etConsoltoStart ===
        VIDABOO_CONSTANTS.TRIGGER_ACTIONS.AUDIO_CALL
    ) {
      const peerUserId = actionClickData.etAgentId;
      if (!peerUserId) {
        console.error(
          'Consolto Widget: tried to open widget without a widgetId',
        );
        return;
      }

      this.setState({actionClickData});
      this.openWidgetByPeerUserIdOrMentorId(peerUserId);
    } else if (
      actionClickData.etClickType === 'start-scheduling' ||
      actionClickData.etConsoltoStart ===
        VIDABOO_CONSTANTS.TRIGGER_ACTIONS.SCHEDULING
    ) {
      const peerUserId = actionClickData.etAgentId;
      if (!peerUserId) {
        console.error(
          'Consolto Widget: tried to open widget without a widgetId',
        );
        return;
      }
      this.setState({actionClickData});
      this.openWidgetByPeerUserIdOrMentorId(peerUserId);
    } else if (
      actionClickData.etClickType === 'start-form' ||
      actionClickData.etConsoltoStart ===
        VIDABOO_CONSTANTS.TRIGGER_ACTIONS.CONTACT_FORM
    ) {
      const peerUserId = actionClickData.etAgentId;
      if (!peerUserId) {
        console.error(
          'Consolto Widget: tried to open widget without a widgetId',
        );
        return;
      }
      this.setState({actionClickData});
      this.openWidgetByPeerUserIdOrMentorId(peerUserId);
    } else if (
      actionClickData.etClickType === 'start-fb-messenger' ||
      actionClickData.etConsoltoStart ===
        VIDABOO_CONSTANTS.TRIGGER_ACTIONS.FB_MESSENGER ||
      actionClickData.etClickType === 'start-custom-link' ||
      actionClickData.etConsoltoStart ===
        VIDABOO_CONSTANTS.TRIGGER_ACTIONS.CUSTOM_LINK ||
      actionClickData.etClickType === 'start-whatsapp' ||
      actionClickData.etConsoltoStart ===
        VIDABOO_CONSTANTS.TRIGGER_ACTIONS.WHATSAPP ||
      actionClickData.etClickType === 'start-phonecall' ||
      actionClickData.etConsoltoStart ===
        VIDABOO_CONSTANTS.TRIGGER_ACTIONS.PHONE_CALL
    ) {
      const peerUserId = actionClickData.etAgentId;
      if (!peerUserId) {
        console.error(
          'Consolto Widget: tried to open widget without a widgetId',
        );
        return;
      }
      this.setState({actionClickData});
      this.openWidgetByPeerUserIdOrMentorId(peerUserId);
    }
  };

  handleListAndChatInteractionModeActionClick = (actionClickData) => {
    const isOneOnOneActionClickData =
      actionClickData.etAgentId === 'AVAILABLE' ||
      actionClickData.etClickType === 'open-widget' ||
      actionClickData.etConsoltoStart ===
        VIDABOO_CONSTANTS.TRIGGER_ACTIONS.OPEN_WIDGET
        ? true
        : !!multiWidgetService.getPeerUserIdUsingMentorId(
            actionClickData.etAgentId,
            this.props.widgetDto.mentorsControlMapDto,
          );

    if (isOneOnOneActionClickData) {
      actionClickData.actionOwnerObjectType =
        VIDABOO_CONSTANTS.MENTOR_OWNER_TYPE.PERSONAL;
      // Supporting legacy
      // in case of single widget, even if agent id is not present -> set the mentorId
      const isSingleWidget =
        Object.keys(this.props.widgetDto.mentorsControlMapDto).length === 1;
      if (isSingleWidget) {
        actionClickData.etAgentId = Object.keys(
          this.props.widgetDto.mentorsControlMapDto,
        )[0];
      }
    } else {
      actionClickData.actionOwnerObjectType =
        VIDABOO_CONSTANTS.MENTOR_OWNER_TYPE.WIDGET;
      const teamMentorId = multiWidgetService.getWidgetTeamMentorIds(
        this.props.widgetDto,
      )[0];
      if (!teamMentorId) {
        console.error(
          'Consolto Widget: tried to perform action with wrong teamMentorId',
        );
        return;
      }
      actionClickData.etAgentId = teamMentorId;
    }

    if (
      actionClickData.clientInfo &&
      actionClickData.cFirstName &&
      actionClickData.cEmail
    ) {
      actionClickData.mentorOwnerId =
        multiWidgetService.getPeerUserIdUsingTeamMentorId(
          actionClickData.etAgentId,
          this.props.widgetDto.teamMentorsMapDto,
        ) ??
        multiWidgetService.getPeerUserIdUsingMentorId(
          actionClickData.etAgentId,
          this.props.widgetDto.mentorsControlMapDto,
        );
      const actionClickExMentorDto =
        multiWidgetService.getExMentorDtoByMentorOwnerId(
          actionClickData.mentorOwnerId,
          this.props.widgetDto,
        );
      if (actionClickExMentorDto) {
        actionClickData.mentorId = actionClickExMentorDto.mentorDto.mentorId;
      }
      if (actionClickData.mentorOwnerId && actionClickData.mentorId) {
        this.setState({actionClickData});
        utilsService.savePeerClientInfo(actionClickData, this.props.widgetDto);
        this.props.widgetContext.setIsPeerClientInfoUpdated(true);
      } else {
        console.error('Consolto Widget: invalid mentorId');
        return;
      }
    }

    if (actionClickData.etClickType === 'close-widget') {
      this.setState(
        {
          actionClickData: null,
          isSingleWidgetMounted: false,
          singleWidgetMentorId: null,
          openSingleWidgetByPeerId: null,
        },
        () => {
          if (this.props.inTeamChatScenario) {
            this.props.moveOutOfTeamChat(() => {
              this.closeMultiWidget(true);
            });
          } else {
            this.closeMultiWidget(true);
          }
        },
      );
      return;
    } else if (actionClickData.etAgentId === 'AVAILABLE') {
      let availableMentorId;
      actionClickData.etAgentId = this.getAvailableAgent();
      const actionClickExMentorDto =
        multiWidgetService.getExMentorDtoByMentorOwnerId(
          actionClickData.etAgentId,
          this.props.widgetDto,
        )?.mentorDto;
      if (actionClickExMentorDto) {
        actionClickData.etAgentId = actionClickExMentorDto.mentorOwnerId;
        availableMentorId = actionClickExMentorDto.mentorId;
      }
      if (this.props.inTeamChatScenario) {
        this.props.handleTransitionToMentorRoom(availableMentorId, null, true);
        this.setState({actionClickData});
        this.openWidgetByPeerUserIdOrMentorId(availableMentorId);
      } else {
        this.setState({actionClickData});
        this.openWidgetByPeerUserIdOrMentorId(actionClickData.etAgentId);
      }
      return;
    }

    if (this.state.isSingleWidgetMounted) {
      if (this.props.inTeamChatScenario) {
        if (
          actionClickData.actionOwnerObjectType ===
          VIDABOO_CONSTANTS.MENTOR_OWNER_TYPE.WIDGET
        ) {
          const validEtClickTypes = [
            'start-chat',
            'start-scheduling',
            'start-form',
            'start-fb-messenger',
            'start-whatsapp',
            'start-phonecall',
            'start-custom-link',
          ];
          const validTriggerActions = [
            VIDABOO_CONSTANTS.TRIGGER_ACTIONS.TEXT_CHAT,
            VIDABOO_CONSTANTS.TRIGGER_ACTIONS.SCHEDULING,
            VIDABOO_CONSTANTS.TRIGGER_ACTIONS.CONTACT_FORM,
            VIDABOO_CONSTANTS.TRIGGER_ACTIONS.FB_MESSENGER,
            VIDABOO_CONSTANTS.TRIGGER_ACTIONS.CUSTOM_LINK,
            VIDABOO_CONSTANTS.TRIGGER_ACTIONS.WHATSAPP,
            VIDABOO_CONSTANTS.TRIGGER_ACTIONS.PHONE_CALL,
          ];
          const shouldHandleActionClickType =
            validEtClickTypes.includes(actionClickData.etClickType) ||
            validTriggerActions.includes(actionClickData.etConsoltoStart);
          if (shouldHandleActionClickType) {
            const peerUserId = actionClickData.etAgentId;
            if (!peerUserId) {
              console.error(
                'Consolto Widget: tried to open widget without team agent id',
              );
              return;
            }
            this.setState({actionClickData});
            this.openWidgetByPeerUserIdOrMentorId(
              peerUserId,
              actionClickData.actionOwnerObjectType,
            );
          } else {
            console.error(
              'Consolto Widget: tried to open widget with invalid action type',
            );
          }
        } else {
          this.props.handleTransitionToMentorRoom(
            actionClickData.etAgentId,
            null,
            true,
          );
          this.setState({actionClickData});
          this.openWidgetByPeerUserIdOrMentorId(actionClickData.etAgentId);
        }
      } else {
        if (
          actionClickData.actionOwnerObjectType ===
          VIDABOO_CONSTANTS.MENTOR_OWNER_TYPE.WIDGET
        ) {
          this.props.handleTransitionToTeamChatRoom();
        } else {
          this.setState({actionClickData});
          this.openWidgetByPeerUserIdOrMentorId(actionClickData.etAgentId);
        }
      }
    } else {
      if (
        actionClickData.etClickType === 'open-widget' ||
        actionClickData.etConsoltoStart ===
          VIDABOO_CONSTANTS.TRIGGER_ACTIONS.OPEN_WIDGET
      ) {
        const peerUserId = actionClickData.etAgentId;
        if (!peerUserId) {
          console.error(
            'Consolto Widget: tried to open widget without a widgetId',
          );
          return;
        }
        this.setState({actionClickData});
        if (actionClickData.etAgentId === 'multi') {
          this.handleActionClickWidgetOpen();
        } else {
          this.openWidgetByPeerUserIdOrMentorId(peerUserId);
        }
      } else {
        if (
          actionClickData.actionOwnerObjectType ===
          VIDABOO_CONSTANTS.MENTOR_OWNER_TYPE.WIDGET
        ) {
          this.props.handleTransitionToTeamChatRoom();
        } else {
          this.setState({actionClickData});
          this.openWidgetByPeerUserIdOrMentorId(actionClickData.etAgentId);
        }
      }
    }
  };

  handleTeamWidgetInteractionModeActionClick = (actionClickData) => {
    actionClickData.actionOwnerObjectType =
      VIDABOO_CONSTANTS.MENTOR_OWNER_TYPE.WIDGET;
    const isOneOnOneActionClickData =
      actionClickData.etAgentId === 'AVAILABLE'
        ? true
        : !!multiWidgetService.getPeerUserIdUsingMentorId(
            actionClickData.etAgentId,
            this.props.widgetDto.mentorsControlMapDto,
          );

    if (isOneOnOneActionClickData) {
      actionClickData.actionOwnerObjectType =
        VIDABOO_CONSTANTS.MENTOR_OWNER_TYPE.PERSONAL;
      // Supporting legacy
      // in case of single widget, even if agent id is not present -> set the mentorId
      const isSingleWidget =
        Object.keys(this.props.widgetDto.mentorsControlMapDto).length === 1;
      if (isSingleWidget) {
        actionClickData.etAgentId = Object.keys(
          this.props.widgetDto.mentorsControlMapDto,
        )[0];
      }
    } else {
      const teamMentorId = multiWidgetService.getWidgetTeamMentorIds(
        this.props.widgetDto,
      )[0];
      if (!teamMentorId) {
        console.error(
          'Consolto Widget: tried to perform action with wrong teamMentorId',
        );
        return;
      }
      actionClickData.etAgentId = teamMentorId;
    }

    if (
      actionClickData.clientInfo &&
      actionClickData.cFirstName &&
      actionClickData.cEmail
    ) {
      actionClickData.mentorOwnerId =
        multiWidgetService.getPeerUserIdUsingTeamMentorId(
          actionClickData.etAgentId,
          this.props.widgetDto.teamMentorsMapDto,
        );
      const actionClickExMentorDto =
        multiWidgetService.getExMentorDtoByMentorOwnerId(
          actionClickData.mentorOwnerId,
          this.props.widgetDto,
        );
      if (actionClickExMentorDto) {
        actionClickData.mentorId = actionClickExMentorDto.mentorDto.mentorId;
      }
      if (actionClickData.mentorOwnerId && actionClickData.mentorId) {
        this.setState({actionClickData});
        utilsService.savePeerClientInfo(actionClickData, this.props.widgetDto);
        this.props.widgetContext.setIsPeerClientInfoUpdated(true);
      } else {
        console.error('Consolto Widget: invalid teamAgentId');
        return;
      }
    }

    if (actionClickData.etClickType === 'close-widget') {
      this.setState(
        {
          actionClickData: null,
          isSingleWidgetMounted: false,
          singleWidgetMentorId: null,
          openSingleWidgetByPeerId: null,
        },
        () => {
          this.closeMultiWidget(true);
        },
      );
      return;
    } else if (actionClickData.etAgentId === 'AVAILABLE') {
      let availableMentorId;
      actionClickData.etAgentId = this.getAvailableAgent();
      const actionClickExMentorDto =
        multiWidgetService.getExMentorDtoByMentorOwnerId(
          actionClickData.etAgentId,
          this.props.widgetDto,
        )?.mentorDto;
      if (actionClickExMentorDto) {
        actionClickData.etAgentId = actionClickExMentorDto.mentorOwnerId;
        availableMentorId = actionClickExMentorDto.mentorId;
      }
      if (this.props.inTeamChatScenario) {
        this.props.handleTransitionToMentorRoom(availableMentorId, null, true);
        this.setState({actionClickData});
        this.openWidgetByPeerUserIdOrMentorId(availableMentorId);
      } else {
        this.setState({actionClickData});
        this.openWidgetByPeerUserIdOrMentorId(actionClickData.etAgentId);
      }
      return;
    }

    if (this.props.inTeamChatScenario) {
      if (
        actionClickData.actionOwnerObjectType ===
        VIDABOO_CONSTANTS.MENTOR_OWNER_TYPE.WIDGET
      ) {
        const validEtClickTypes = [
          'open-widget',
          'start-chat',
          'start-scheduling',
          'start-form',
          'start-fb-messenger',
          'start-whatsapp',
          'start-phonecall',
          'start-custom-link',
        ];
        const validTriggerActions = [
          VIDABOO_CONSTANTS.TRIGGER_ACTIONS.OPEN_WIDGET,
          VIDABOO_CONSTANTS.TRIGGER_ACTIONS.TEXT_CHAT,
          VIDABOO_CONSTANTS.TRIGGER_ACTIONS.SCHEDULING,
          VIDABOO_CONSTANTS.TRIGGER_ACTIONS.CONTACT_FORM,
          VIDABOO_CONSTANTS.TRIGGER_ACTIONS.FB_MESSENGER,
          VIDABOO_CONSTANTS.TRIGGER_ACTIONS.WHATSAPP,
          VIDABOO_CONSTANTS.TRIGGER_ACTIONS.PHONE_CALL,
          VIDABOO_CONSTANTS.TRIGGER_ACTIONS.CUSTOM_LINK,
        ];

        const shouldHandleActionClickType =
          validEtClickTypes.includes(actionClickData.etClickType) ||
          validTriggerActions.includes(actionClickData.etConsoltoStart);
        if (shouldHandleActionClickType) {
          const peerUserId = actionClickData.etAgentId;
          if (!peerUserId) {
            console.error(
              'Consolto Widget: tried to open widget without team agent id',
            );
            return;
          }
          this.setState({actionClickData});
          this.openWidgetByPeerUserIdOrMentorId(
            peerUserId,
            actionClickData.actionOwnerObjectType,
          );
        } else {
          console.error(
            'Consolto Widget: tried to open widget with invalid action type',
          );
        }
      } else {
        this.props.handleTransitionToMentorRoom(
          actionClickData.etAgentId,
          null,
          true,
        );
        this.setState({actionClickData});
        this.openWidgetByPeerUserIdOrMentorId(actionClickData.etAgentId);
      }
    } else {
      if (
        actionClickData.actionOwnerObjectType ===
        VIDABOO_CONSTANTS.MENTOR_OWNER_TYPE.WIDGET
      ) {
        this.props.handleTransitionToTeamChatRoom();
      } else {
        this.setState({actionClickData});
        this.openWidgetByPeerUserIdOrMentorId(actionClickData.etAgentId);
      }
    }
  };

  handleActionClickWidgetOpen = () => {
    if (this.state.isEntireWidgetHidden) {
      this.setState({isEntireWidgetHidden: false});
    }
    //while open widget if filteredSortedMentorsCtrlDtoValues empty -> show all agents
    let maxNumOfWidgets = Object.keys(
      this.state.widgetDto.mentorsControlMapDto,
    )?.length;
    let shouldSkipAgentListUI = false;
    const allSortedMentorsCtrlDtoValues =
      this.handleMentorsCtrlMapDtoSortAndFiltering(
        this.state.widgetDto,
        maxNumOfWidgets,
        true,
      );
    maxNumOfWidgets = allSortedMentorsCtrlDtoValues.length;
    if (allSortedMentorsCtrlDtoValues.length === 1) {
      this.isSingleWidget = true;
      this.isMultiWidget = false;
      shouldSkipAgentListUI = true;
    }
    this.setState(
      {
        shouldSkipAgentListUI,
        maxNumOfWidgets,
        filteredSortedMentorsCtrlDtoValues: allSortedMentorsCtrlDtoValues,
      },
      () => {
        PostMessageService.setNumOfWidgets(maxNumOfWidgets);
        this.handleMentorsOrderAndListeningRoom(this.state.widgetDto, true);
        this.openMultiWidget();
      },
    );
  };

  openWidgetByPeerUserIdOrMentorId = (
    peerUserIdOrMentorId,
    actionOwnerObjectType = VIDABOO_CONSTANTS.MENTOR_OWNER_TYPE.PERSONAL,
  ) => {
    if (actionOwnerObjectType === VIDABOO_CONSTANTS.MENTOR_OWNER_TYPE.WIDGET) {
      this.openMultiWidget();
    } else {
      let mentorId = multiWidgetService.getMentorIdsUsingPeerUserIdOrMentorId(
        peerUserIdOrMentorId,
        this.props.widgetDto.mentorsControlMapDto,
      )?.[0];
      if (mentorId) {
        let widgetDto = JSON.parse(JSON.stringify(this.props.widgetDto));

        widgetDto.mentorsControlMapDto[mentorId].extendedMentorDto.isVisible =
          true;
        widgetDto.mentorsControlMapDto[
          mentorId
        ].extendedMentorDto.passedPageRegex = true;
        //for some conditions we were not listening to this agent -> start listening now
        // const agentUserId =
        // widgetDto.mentorsControlMapDto[mentorId].extendedMentorDto.mentorDto
        //   .userId;
        // this.listenToPeerAvailabilityChanges(agentUserId, widgetDto);

        this.setState({
          widgetDto,
          openSingleWidgetByPeerId: mentorId,
        });
        this.openMultiWidget();
      } else {
        console.error(
          'Consolto Widget: tried to open mentor with a wrong mentorId. Please make sure you provided the right mentorId and widget is active.',
        );
      }
    }
  };

  handleWidgetAutoPopup = (widgetDto, forceAutoPopup) => {
    const widgetAppCtrlDto = widgetDto.widgetAppCtrlDto;
    if (!this.isInPersonalPage) {
      if (this.widgetAutoPopupTimeout) {
        window.clearTimeout(this.widgetAutoPopupTimeout);
      }
      const autoPopupTime = forceAutoPopup
        ? 0
        : widgetAppCtrlDto.autoPopupTime || widgetAppCtrlDto.autoPopupTime === 0
          ? widgetAppCtrlDto.autoPopupTime * 1000
          : VIDABOO_CONSTANTS.CHAT_AUTO_RESPONDER
              .DEFAULT_TIME_BEFORE_AUTO_CHAT_POPS;
      if (
        !utilsService.isMobileDevice() || //todomcss : ok
        (utilsService.isMobileDevice() && //todomcss : ok
          !widgetAppCtrlDto.disablePopupOnMobile) ||
        forceAutoPopup
      ) {
        this.widgetAutoPopupTimeout = setTimeout(() => {
          if (
            this.state.widgetMode === VIDABOO_CONSTANTS.WIDGET_MODES.MASK_MODE
          ) {
            this.openMultiWidget();
          }
        }, autoPopupTime);
      }
    }
  };

  setWidgetProfileImgAndVideoBgUrl = () => {
    const widgetDto = this.props.widgetDto;
    //set widget profile image
    const widgetProfilePhotoDto =
      utilsService.getPhotoDtoAndIdxByPhotoAndObjectType(
        widgetDto.widgetAppCtrlDto.photoDtos,
        VIDABOO_CONSTANTS.PHOTO_TYPES.PROFILE,
        VIDABOO_CONSTANTS.PHOTO_OBJECT_TYPES.WIDGET,
      )?.photoDto;
    if (widgetProfilePhotoDto) {
      const manipulatedPhotoUrl = utilsService.getPhotoManipulatedUrl(
        widgetProfilePhotoDto,
        VIDABOO_CONSTANTS.CLOUDINARY_IMAGE_MANIPULATIONS.WIDGET_MASK_IMAGE,
      );
      this.setState({widgetProfileImage: manipulatedPhotoUrl});
    } else if (this.isSingleWidget) {
      //if single widget and widget profile image is not set by mentor but agent image exist then we need to use agent image as widgetProfileImage
      const widgetMentorCtrlDtos = Object.values(
        widgetDto.mentorsControlMapDto,
      );
      const photoDto = widgetMentorCtrlDtos[0].extendedMentorDto.photoDto;
      if (photoDto?.photoUrl) {
        const manipulatedPhotoUrl = utilsService.getPhotoManipulatedUrl(
          photoDto,
          VIDABOO_CONSTANTS.CLOUDINARY_IMAGE_MANIPULATIONS.WIDGET_MASK_IMAGE,
        );
        this.setState({widgetProfileImage: manipulatedPhotoUrl});
      }
    }
    //set widget video background video url
    const widgetVideoBgPhotoDto =
      utilsService.getPhotoDtoAndIdxByPhotoAndObjectType(
        widgetDto.widgetAppCtrlDto.photoDtos,
        VIDABOO_CONSTANTS.PHOTO_TYPES.VIDEO_BACKGROUND,
        VIDABOO_CONSTANTS.PHOTO_OBJECT_TYPES.WIDGET,
      )?.photoDto;
    if (widgetVideoBgPhotoDto) {
      const manipulatedVideoBgUrl = utilsService.getPhotoManipulatedUrl(
        widgetVideoBgPhotoDto,
        VIDABOO_CONSTANTS.CLOUDINARY_IMAGE_MANIPULATIONS.WIDGET_MASK_VIDEO,
      );
      this.setState({widgetVideoBgUrl: manipulatedVideoBgUrl});
    }
  };

  listenToPeerAvailabilityChanges = (agentUserId, widgetDto) => {
    // This method is responsible for registering listeners to availability of all the agents. It will update changes in the general context.
    if (
      this.props.isDemo ||
      this.deleteDoWhenAvailabilityStateChanged[agentUserId]
    )
      return;
    this.deleteDoWhenAvailabilityStateChanged[agentUserId] =
      peerAvailabilityStateService.doWhenAvailabilityStateChanged(
        agentUserId,
        (newAvailabilityState) => {
          // console.debug('new availability state: ' + newAvailabilityState);
          this.context.setPeerStatus(agentUserId, newAvailabilityState);

          if (
            utilsService.getIsInWidget() &&
            widgetDto.widgetAppCtrlDto.dispatchConsoltoWidgetEvents
          ) {
            PostMessageService.sendEventToHost({
              category:
                VIDABOO_CONSTANTS.ANALYTICS_CATEGORIES.WIDGET_FOR_PARENT_FRAME,
              action:
                VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET
                  .AVAILABILITY_STATE_CHANGE,
              label: agentUserId,
              value: newAvailabilityState,
              eventName: VIDABOO_CONSTANTS.FORWARD_EVENTS.PEER_STATUS, // keeping for legacy
              agentUserId, // keeping for legacy
              mentorIds:
                multiWidgetService.getMentorIdsUsingPeerUserIdOrMentorId(
                  agentUserId,
                  widgetDto.mentorsControlMapDto,
                ),
              newAvailabilityState, // keeping for legacy
            });
          }
        },
      );
    this.deleteConnectToPeerShoutingRoom[agentUserId] =
      ShoutingRoomService.connectToPeerShoutingRoom(
        agentUserId,
        this.context.currentUser.userId,
      );
    this.deleteConnectToPeerListeningRoom[agentUserId] =
      ListeningRoomService.connectToPeerListeningRoom(
        agentUserId,
        this.context.currentUser.userId,
      );
  };
  validatePageRegexes = (pageRegexArr) => {
    if (
      pageRegexArr === undefined ||
      pageRegexArr === null ||
      pageRegexArr.length === 0 ||
      this.props.isDemo
    )
      return true;
    const currentParentFullPath = PostMessageService.getLocation();
    if (currentParentFullPath === undefined || currentParentFullPath === null) {
      // in this case we cannot perform regex check. will wait for few moments and try again.
      if (this.state.validatePageRegexesTrials <= 8) {
        this.validatePageRegexTimeout = setTimeout(() => {
          this.setState({
            validatePageRegexesTrials: this.state.validatePageRegexesTrials + 1,
          });
          return this.validatePageRegexes(pageRegexArr);
        }, 500);
      } else return false;
    } else {
      for (let index = 0; index < pageRegexArr.length; index++) {
        if (currentParentFullPath.fullUrl.search(pageRegexArr[index]) >= 0) {
          return true;
        }
      }

      return false;
    }
  };
  setLastMWClose = (closed) => {
    if (!this.props.isDemo) {
      if (utilsService.isLocalStorageSupported()) {
        // just been closed
        let lastMWCloseTime = storageService.getItem('lastMWClose');
        let lastMultiWidgetCloseTimes;
        if (lastMWCloseTime === null || lastMWCloseTime === undefined) {
          lastMultiWidgetCloseTimes = {};
        } else {
          lastMultiWidgetCloseTimes = JSON.parse(lastMWCloseTime);
        }
        if (closed) {
          let now = new Date().getTime();
          lastMultiWidgetCloseTimes[this.state.widgetDto.widgetId] = now;
        } else {
          lastMultiWidgetCloseTimes[this.state.widgetDto.widgetId] = 0;
        }
        storageService.setItem(
          'lastMWClose',
          JSON.stringify(lastMultiWidgetCloseTimes),
        ); // saving mentorUserId and lastTime autoChat was popped up
      }
    }
  };
  getValidatedPageRegexValue = () => {
    return this.validatePageRegexes(
      this.state.widgetDto.widgetAppCtrlDto.pagesRegexes,
    );
  };
  shouldHideEntireWidget = () => {
    return (
      this.state.maxNumOfWidgets <= 0 ||
      !this.getValidatedPageRegexValue() ||
      !this.state.widgetDto.widgetAppCtrlDto.widgetVisible
    );
  };
  openMultiWidget = () => {
    //once we open the widget, no need of auto popup
    if (this.widgetAutoPopupTimeout) {
      window.clearTimeout(this.widgetAutoPopupTimeout);
    }
    // 1. widgetMask itself opens the widget
    // 2. AutoPopup - at the benning of the load we open if widget should start in ACCOUNT_MODE.
    // 3. Triggered from external button when widgetMode is either single / multi / maskText
    this.showEntireWidget();

    /**
     * Prevent if user try to open widget with same etAgentId
     */

    if (
      this.state.actionClickData &&
      this.state.actionClickData?.etAgentId !== 'multi' &&
      this.state.widgetMode ===
        VIDABOO_CONSTANTS.WIDGET_MODES.SINGLE_EXPERT_MODE
    ) {
      return;
    }

    let newWidgetMode = VIDABOO_CONSTANTS.WIDGET_MODES.ACCOUNT_MODE;
    let newWidgetSize = VIDABOO_CONSTANTS.WIDGET_SIZE.ACCOUNT_WIDGET_OPEN;
    if (
      this.state.widgetMode ===
      VIDABOO_CONSTANTS.WIDGET_MODES.SINGLE_EXPERT_MODE
    ) {
      // do nothing.
    } else if (
      this.state.widgetMode === VIDABOO_CONSTANTS.WIDGET_MODES.ACCOUNT_MODE
    ) {
      // Do nothing. Shouldn't be handled here.
    } else if (
      this.state.widgetMode === VIDABOO_CONSTANTS.WIDGET_MODES.MASK_MODE
    ) {
      newWidgetMode = VIDABOO_CONSTANTS.WIDGET_MODES.ACCOUNT_MODE;
      newWidgetSize = VIDABOO_CONSTANTS.WIDGET_SIZE.ACCOUNT_WIDGET_OPEN;
      if (!this.props.isDemo) {
        PostMessageService.postMessageResize(
          newWidgetSize,
          'multiWidgetContainer',
        );
      }
    } else if (
      this.state.widgetMode === VIDABOO_CONSTANTS.WIDGET_MODES.HIDDEN_MODE
    ) {
      newWidgetMode = VIDABOO_CONSTANTS.WIDGET_MODES.ACCOUNT_MODE;
      newWidgetSize = VIDABOO_CONSTANTS.WIDGET_SIZE.ACCOUNT_WIDGET_OPEN;
      if (!this.props.isDemo) {
        PostMessageService.postMessageResize(
          newWidgetSize,
          'multiWidgetContainer',
        );
      }
    }

    if (
      this.isMultiWidget &&
      newWidgetMode === VIDABOO_CONSTANTS.WIDGET_MODES.ACCOUNT_MODE
    ) {
      //widget will open
      this.sendGA(
        VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET.OPEN_PRE_WIDGET,
        this.state.widgetDto.accountId +
          ',wid:' +
          this.state.widgetDto.widgetId,
      );
      this.dispatchConsoltoEvents(
        VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET.OPEN_PRE_WIDGET,
        this.state.widgetDto.widgetId,
      );
    }
    this.setLastMWClose(false);
    this.setState({
      widgetMode: newWidgetMode,
    });
  };
  closeMultiWidget = (shouldResetToMaskState) => {
    // 1. Triggered from within singleWidget when closing.  ==> need to check if hidden...
    // 2. Triggered from external button when widgetMode is either single / multi / maskText ==> we do nothing.
    // 4. Multi-widget closes
    if (this.props.isDemo) {
      this.props.closeMultiWidget();
    }

    const widgetWasOpenedByActionClick = !!this.state.actionClickData;
    if (
      widgetWasOpenedByActionClick &&
      this.state.actionClickData.etClickType !== 'close-widget'
    ) {
      console.debug(
        'We pressed externalClick hence this should not close the widget',
      );
      return;
    }

    let newWidgetMode = VIDABOO_CONSTANTS.WIDGET_MODES.HIDDEN_MODE;
    if (
      this.state.widgetMode ===
      VIDABOO_CONSTANTS.WIDGET_MODES.SINGLE_EXPERT_MODE
    ) {
      if (this.shouldHideEntireWidget()) {
        newWidgetMode = VIDABOO_CONSTANTS.WIDGET_MODES.HIDDEN_MODE;
      } else if (shouldResetToMaskState) {
        newWidgetMode = VIDABOO_CONSTANTS.WIDGET_MODES.MASK_MODE;
      } else newWidgetMode = VIDABOO_CONSTANTS.WIDGET_MODES.ACCOUNT_MODE; // todo - handle later case where only one agent shown - then go to MASK.
    } else if (
      this.state.widgetMode === VIDABOO_CONSTANTS.WIDGET_MODES.ACCOUNT_MODE
    ) {
      if (this.shouldHideEntireWidget()) {
        newWidgetMode = VIDABOO_CONSTANTS.WIDGET_MODES.HIDDEN_MODE;
      } else newWidgetMode = VIDABOO_CONSTANTS.WIDGET_MODES.MASK_MODE;
    }

    if (!this.props.isDemo) {
      const newSize =
        newWidgetMode === VIDABOO_CONSTANTS.WIDGET_MODES.MASK_MODE
          ? VIDABOO_CONSTANTS.WIDGET_SIZE.WIDGET_CLOSED
          : newWidgetMode === VIDABOO_CONSTANTS.WIDGET_MODES.ACCOUNT_MODE
            ? VIDABOO_CONSTANTS.WIDGET_SIZE.ACCOUNT_WIDGET_OPEN
            : newWidgetMode === VIDABOO_CONSTANTS.WIDGET_MODES.HIDDEN_MODE
              ? VIDABOO_CONSTANTS.WIDGET_SIZE.WIDGET_CLOSED
              : VIDABOO_CONSTANTS.WIDGET_SIZE.WIDGET_CLOSED; // this would be an error.
      // if widget is in size of Single expert widget then don't change size
      PostMessageService.postMessageResize(newSize, 'multiWidgetContainer');
      if (newWidgetMode === VIDABOO_CONSTANTS.WIDGET_MODES.HIDDEN_MODE)
        this.hideEntireWidget();
    }
    if (this.isMultiWidget) {
      if (newWidgetMode === VIDABOO_CONSTANTS.WIDGET_MODES.ACCOUNT_MODE) {
        //widget will open
        this.sendGA(
          VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET.OPEN_PRE_WIDGET,
          this.state.widgetDto.accountId +
            ',wid:' +
            this.state.widgetDto.widgetId,
        );
        this.dispatchConsoltoEvents(
          VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET.OPEN_PRE_WIDGET,
          this.state.widgetDto.widgetId,
        );
      } else {
        // widget will close
        this.sendGA(
          VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET.CLOSE_ACCOUNT_WIDGET,
          this.state.widgetDto.accountId +
            ',wid:' +
            this.state.widgetDto.widgetId,
        );
        this.dispatchConsoltoEvents(
          VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET.CLOSE_ACCOUNT_WIDGET,
          this.state.widgetDto.widgetId,
        );
      }
    }

    this.setState({
      actionClickData: null,
      widgetMode: newWidgetMode,
      openSingleWidgetByPeerId: null,
    });
  };
  setWidgetMode = (widgetMode) => {
    this.setState({widgetMode});
  };
  hideEntireWidget = () => {
    const newWidgetMode = VIDABOO_CONSTANTS.WIDGET_MODES.HIDDEN_MODE;
    const newWidgetSize = VIDABOO_CONSTANTS.WIDGET_SIZE.WIDGET_CLOSED;
    this.setState({widgetMode: newWidgetMode});
    if (!this.props.isDemo) {
      PostMessageService.postMessageResize(
        newWidgetSize,
        'multiWidgetContainer',
      );
      PostMessageService.postMessageHide('hidden', 'multiWidgetContainer');
    }
  };
  showEntireWidget = () => {
    PostMessageService.postMessageHide('visible', 'multiWidgetContainer');
  };

  getPageLocation = () => {
    let pageLocation = PostMessageService.getLocation();
    let error = false;
    if (
      utilsService.getIsInWidget() === true ||
      utilsService.getIsEmbeddedPersonalPage() === true
    ) {
      if (!pageLocation) {
        error = true;
        pageLocation = {
          fullUrl: window.location && window.location.href,
          hostUrl: 'Error Retrieving URL from host',
          error: error,
        };
      }
    } else {
      pageLocation = {
        protocol: window.top.location.protocol,
        fullUrl: window.top.location.href,
        hostUrl: window.top.location.origin,
        pageUrl: window.top.location.pathname,
        hashUrl: window.top.location.hash,
        searchStr: window.top.location.search,
      };
    }
    return pageLocation;
  };

  setIsSingleWidgetMounted = (isSingleWidgetMounted) => {
    this.setState({isSingleWidgetMounted});
  };

  openWidgetByTabType = ({
    mentorId,
    selectedWidgetAppType,
    etClickInitiator,
    roomOwnerObjectType,
  }) => {
    if (!this.props.isDemo) {
      const etClickType = utilsService.getEtClickTypeByWidgetAppType(
        selectedWidgetAppType,
      );
      const actionOwnerObjectType =
        roomOwnerObjectType ===
        VIDABOO_CONSTANTS.CHAT_ROOM_OWNER_TYPE.TEAM_MENTOR
          ? VIDABOO_CONSTANTS.MENTOR_OWNER_TYPE.WIDGET
          : VIDABOO_CONSTANTS.MENTOR_OWNER_TYPE.PERSONAL;
      if (etClickType) {
        const actionClickData = {
          etAgentId: mentorId,
          etClickType,
          etClickInitiator,
        };
        this.setState({actionClickData});
      }
      this.openWidgetByPeerUserIdOrMentorId(mentorId, actionOwnerObjectType);
    }
  };

  setSingleWidgetMentorId = (singleWidgetMentorId) => {
    this.setState({singleWidgetMentorId});
  };

  resetActionClickData = () => {
    this.setState({actionClickData: null});
  };

  handleHoverStateChangeForSlidingWidget = (state, status) => {
    this.setState({[state]: status});
  };

  setIsInitialWidgetTextShown = () => {
    this.setState({isInitialWidgetTextShown: true});
  };

  onHeaderBackButton = () => {
    const shouldMoveOutOfTeamChat =
      this.props.inTeamChatScenario &&
      this.state.widgetDto.widgetAppCtrlDto.widgetInteractionMode ===
        VIDABOO_CONSTANTS.WIDGET_INTERACTION_MODE.LIST_AND_CHAT;
    this.setState(
      {
        actionClickData: null,
        isSingleWidgetMounted: false,
        singleWidgetMentorId: null,
        openSingleWidgetByPeerId: null,
      },
      () => {
        if (this.props.canMoveToTeamChat) {
          this.props.handleTransitionToTeamChatRoom();
        } else {
          this.closeMultiWidget();
        }
        if (shouldMoveOutOfTeamChat) {
          this.props.moveOutOfTeamChat();
        }
      },
    );
  };

  onHeaderCloseButton = () => {
    const shouldMoveOutOfTeamChat =
      this.props.inTeamChatScenario &&
      this.state.widgetDto.widgetAppCtrlDto.widgetInteractionMode ===
        VIDABOO_CONSTANTS.WIDGET_INTERACTION_MODE.LIST_AND_CHAT;
    this.setState(
      {
        actionClickData: null,
        isSingleWidgetMounted: false,
        singleWidgetMentorId: null,
        openSingleWidgetByPeerId: null,
      },
      () => {
        this.setLastMWClose(true);
        if (shouldMoveOutOfTeamChat) {
          this.props.moveOutOfTeamChat(() => {
            this.closeMultiWidget(true);
          });
        } else {
          this.closeMultiWidget(true);
        }
      },
    );
  };

  render() {
    return (
      <>
        {' '}
        {this.state.widgetDto && (
          <div
            className={`et-multi-expert-widget-container ${utilsService.getIsEmbeddedPersonalPage() === true ? 'et-embedded-clickntalk-wrap' : ''} ${utilsService.isMobileDevice() ? 'et-mobile-device' : ''}`}>
            {!this.props.isDemo &&
              !utilsService.isEmptyHash(this.state.widgetDto) && (
                <React.Fragment>
                  <MultiDagComponent
                    widgetDto={this.state.widgetDto}
                    currentUser={this.context.currentUser}
                    getPageLocation={this.getPageLocation}
                    inTeamChatScenario={this.props.inTeamChatScenario}
                    isSingleWidgetMounted={this.state.isSingleWidgetMounted}
                    singleWidgetMentorId={this.state.singleWidgetMentorId}
                  />
                  {((this.state.widgetDto?.widgetAppCtrlDto
                    ?.widgetInteractionMode ===
                    VIDABOO_CONSTANTS.WIDGET_INTERACTION_MODE.TEAM_LIST &&
                    !this.state.isSingleWidgetMounted) ||
                    [
                      VIDABOO_CONSTANTS.WIDGET_INTERACTION_MODE.LIST_AND_CHAT,
                      VIDABOO_CONSTANTS.WIDGET_INTERACTION_MODE.TEAM_WIDGET,
                    ].includes(
                      this.state.widgetDto?.widgetAppCtrlDto
                        ?.widgetInteractionMode,
                    )) && (
                    <MultiEngagerReceiverComponent
                      isSingleWidgetMounted={this.state.isSingleWidgetMounted}
                      inTeamChatScenario={this.props.inTeamChatScenario}
                      currentUser={this.context.currentUser}
                      widgetInteractionMode={
                        this.state.widgetDto?.widgetAppCtrlDto
                          ?.widgetInteractionMode
                      }
                      handleTransitionToMentorRoom={
                        this.props.handleTransitionToMentorRoom
                      }
                      handleTransitionToTeamChatRoom={
                        this.props.handleTransitionToTeamChatRoom
                      }
                      openWidgetByTabType={this.openWidgetByTabType}
                      changeIframeSize={this.changeIframeSize}
                      widgetContext={this.props.widgetContext}
                    />
                  )}
                </React.Fragment>
              )}
            {!this.props.isDemo &&
            !this.isInPersonalPage &&
            [
              VIDABOO_CONSTANTS.WIDGET_MODES.MASK_MODE,
              VIDABOO_CONSTANTS.WIDGET_MODES.HIDDEN_MODE,
            ].includes(this.state.widgetMode) ? (
              <>
                {this.props.isChatTransitionFlowRunning ||
                this.state.isSingleWidgetMounted ? (
                  <></>
                ) : (
                  <WidgetMaskComponentV2
                    isEntireWidgetHidden={this.state.isEntireWidgetHidden}
                    isInitialWidgetTextShown={
                      this.state.isInitialWidgetTextShown
                    }
                    profileImage={this.state.widgetProfileImage}
                    widgetMaskText={
                      this.state.widgetDto?.widgetAppCtrlDto
                        ?.widgetEditableTexts &&
                      this.state.widgetDto.widgetAppCtrlDto.widgetEditableTexts[
                        VIDABOO_CONSTANTS.WIDGET_EDITABLE_TEXTS.PRE_WIDGET_TEXT
                      ]
                    }
                    widgetMaskType={
                      this.state.widgetDto?.widgetAppCtrlDto?.closedWidgetType
                    }
                    widgetVideoBgUrl={this.state.widgetVideoBgUrl}
                    changeIframeSize={this.changeIframeSize}
                    openWidget={this.openMultiWidget}
                    setIsInitialWidgetTextShown={
                      this.setIsInitialWidgetTextShown
                    }
                    widgetLocation={
                      this.state.widgetDto?.widgetAppCtrlDto.style
                        .locationOnScreen
                    }
                  />
                )}
              </>
            ) : (
              <>
                <OpenMultiWidgetComponent
                  canMoveToTeamChat={this.props.canMoveToTeamChat}
                  isDemo={this.props.isDemo}
                  isInPersonalPage={this.isInPersonalPage}
                  isSingleWidget={this.isSingleWidget}
                  isMultiWidget={
                    (!this.isInPersonalPage && !this.isSingleWidget) ||
                    this.props.isDirectory
                  }
                  isEntireWidgetHidden={this.state.isEntireWidgetHidden}
                  inTeamChatScenario={this.props.inTeamChatScenario}
                  demoOpenCloseWidget={this.props.demoOpenCloseWidget}
                  doWhenActionClick={this.doWhenActionClick}
                  resetActionClickData={this.resetActionClickData}
                  shouldSkipAgentListUI={this.state.shouldSkipAgentListUI}
                  profileName={this.props.profileName}
                  widgetDto={this.state.widgetDto}
                  filteredSortedMentorsCtrlDtoValues={
                    this.state.filteredSortedMentorsCtrlDtoValues
                  }
                  closeMultiWidget={this.closeMultiWidget}
                  openMultiWidget={this.openMultiWidget}
                  openWidgetByTabType={this.openWidgetByTabType}
                  changeIframeSize={this.changeIframeSize}
                  openSingleWidgetByPeerId={this.state.openSingleWidgetByPeerId}
                  resetOpenSingleWidgetByPeerIdAndActionClickData={(cb) => {
                    this.setState(
                      {
                        openSingleWidgetByPeerId: null,
                        actionClickData: null,
                      },
                      () => {
                        cb(this.state);
                      },
                    );
                  }}
                  // maxNumOfWidgets={this.state.maxNumOfWidgets}
                  actionClickData={this.state.actionClickData}
                  bfi={this.props.bfi}
                  startValueFromQuery={this.props.startValueFromQuery}
                  setLastMWClose={this.setLastMWClose}
                  dispatchConsoltoEvents={this.dispatchConsoltoEvents}
                  shouldHideEntireWidget={this.shouldHideEntireWidget}
                  widgetMode={this.state.widgetMode}
                  setWidgetMode={this.setWidgetMode}
                  setIsSingleWidgetMounted={this.setIsSingleWidgetMounted}
                  setSingleWidgetMentorId={this.setSingleWidgetMentorId}
                  getPageLocation={this.getPageLocation}
                  setNotificationPopUpData={this.props.setNotificationPopUpData}
                  isAutomatedCallHandled={this.props.isAutomatedCallHandled}
                  setIsAutomatedCallHandled={
                    this.props.setIsAutomatedCallHandled
                  }
                  handleTransitionToTeamChatRoom={
                    this.props.handleTransitionToTeamChatRoom
                  }
                  onHeaderBackButton={this.onHeaderBackButton}
                  onHeaderCloseButton={this.onHeaderCloseButton}
                />
              </>
            )}
          </div>
        )}
      </>
    );
  }
}
MultiExpertWidget.contextType = AppContext;
export default withWidgetContext(MultiExpertWidget);
